// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue"
import App from "./App"
import router from "./router"
import ElementUI from "element-ui"
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
// import Viewer from "v-viewer"
// import "viewerjs/dist/viewer.css"
// import preview from 'vue-photo-preview'
// import 'vue-photo-preview/dist/skin.css'
import 'animate.css'


import "element-ui/lib/theme-chalk/index.css"
import "element-ui/lib/theme-chalk/display.css"
import "quill/dist/quill.core.css"

import { getUUID } from '@/utils/uuid_token'

// import * as echarts from 'echarts'
import Logindialog from '@/components/logindialog'
import LoginOpen from '@/components/loginOpen'
import BuyConfirm from "@/components/buyconfirm.vue"
import store from './store'
Vue.component(Logindialog.name, Logindialog)
Vue.component(LoginOpen.name, LoginOpen)
Vue.component(BuyConfirm.name, BuyConfirm)


//支持搜索繁体字
function zhengzepinjie (chinastr) {
  chinastr = chinastr.replace(/[`:_.~!@#$%^&*() \+ =<>?"{}|, \/ ;' \\ [ \] ·~！@#￥%……&*（）—— \+ ={}|《》？：“”【】、；‘’，。、]/g,
    '')
  // console.log(chinastr, 'chinastr')
  let newstr = ''
  let datamap = localStorage.datamap ? JSON.parse(localStorage.datamap) : {}
  if (!datamap) { return chinastr }

  // let khcount = 0//统计几个小括号

  for (let i = 0; i < chinastr.length; i++) {
    var code = chinastr.charCodeAt(i)

    let chinakey = ''
    if (code > + 0xD800 && code <= 0xDFFF) {
      chinakey = chinastr.substr(i, 2)
      i++

    } else {
      chinakey = chinastr.substr(i, 1)
    }

    if (datamap[chinakey]) {
      // khcount++
      if (i + 1 == chinastr.length) {
        newstr += datamap[chinakey]
      } else {
        newstr += datamap[chinakey] + "[^\u4e00-\u9fa5\u3400-\u4dbf\uf900-\ufaff\uD800-\uDFFF]{0,}"
      }
    }
    else {
      if (i + 1 == chinastr.length) {
        newstr += chinakey
      } else {
        newstr += chinakey + "[^\u4e00-\u9fa5\u3400-\u4dbf\uf900-\ufaff\uD800-\uDFFF]{0,}"
      }

    }
  }
  // let dd = new RegExp("(" + newstr + ")", "g")
  // console.log(dd)
  return newstr
}
//正则拼接不忽略标点
function zhengzepinjienew (chinastr) {

  // console.log(chinastr, 'chinastr')
  let newstr = ''
  let datamap = localStorage.datamap ? JSON.parse(localStorage.datamap) : {}
  if (!datamap) { return chinastr }

  // let khcount = 0//统计几个小括号

  for (let i = 0; i < chinastr.length; i++) {
    var code = chinastr.charCodeAt(i)

    let chinakey = ''
    if (code > + 0xD800 && code <= 0xDFFF) {
      chinakey = chinastr.substr(i, 2)
      i++

    } else {
      chinakey = chinastr.substr(i, 1)
    }

    if (datamap[chinakey]) {
      // khcount++
      newstr += datamap[chinakey]
    }
    else {
      newstr += chinakey
    }
  }
  // let dd = new RegExp("(" + newstr + ")", "g")
  // console.log(dd)
  return newstr
}

// 搜索高亮
Vue.prototype.brightenKeyword = function (val, keyword, noteOrQa, searchAccuracyType, underline = "", markMapitem = []) {
  // 还可以用作你阅读器的高亮，几个分隔符我跟你说下 云~$花蕋~!书   ~代表关键字的分隔符，$意思是条件or， !意思是条件not, 关键字前面没有 $和!代表 and
  //你需要处理的高亮是or和and的条件，not条件不高亮  目前说的都还是没加near搜索的时候哈
  // console.log(markMapitem, 'markMapitem')

  if (!keyword && (JSON.stringify(noteOrQa) == "{}" || noteOrQa == undefined) && !underline && markMapitem.length == 0) return val
  if (!val) return val

  var newval = val
  // if (underline) {

  //   newval = this.underLine(val, underline)
  // }
  if (underline) {
    let noteOrQaArr = underline.split(" ")
    // console.log(noteOrQaArr, 'noteOrQaArr')
    for (let i = noteOrQaArr.length - 1; i >= 0; i--) {
      if (noteOrQaArr[i] == '') continue
      newval = newval.replace(
        new RegExp(noteOrQaArr[i]), //笔记与反馈 公用高亮逻辑
        (text) => {

          return `<span class="bolang">${text}</span>`

        }
      )
    }

  }

  if (keyword) {
    let kleng = keyword.length
    let wz = keyword.indexOf('d')

    if (wz == -1 || wz == kleng - 1) {  //一般搜索和进阶搜索
      if (wz == kleng - 1) keyword = keyword.slice(0, wz)
      // console.log(wz,kleng,keyword,'wz');
      let keywordarr = keyword.split("~")
      // console.log(keywordarr, 'keywordarr')

      for (let i = 0; i < keywordarr.length; i++) {
        let keyw = keywordarr[i]
        if (keyw.indexOf("!") > -1) continue
        if (keyw.indexOf("$") > -1) keyw = keyw.slice(1)
        // console.log(keyw,'keyw');
        if (keyw.length > 0) {
          // [叶协愶恊葉][叶协愶恊葉音]
          let patern = new RegExp("(" + searchAccuracyType ? zhengzepinjie(keyw) : keyw + ")", "g")//正则
          // console.log(newval, patern, 'arr')
          var arr = newval.match(patern)
          var a = -1
          newval = newval.replace(
            patern, function (rs, $1) {
              a++
              return '<span class="sehightText">' + arr[a] + "</span>"
            }
          )

        }
      }

    } else {  //near搜索
      let temparr = keyword.split('d')
      let spacearr = temparr[1].split(',')
      let keyarr = temparr[0].split('~')

      let res0 = searchAccuracyType ? zhengzepinjie(keyarr[0]) : keyarr[0]
      let res1 = searchAccuracyType ? zhengzepinjie(keyarr[1]) : keyarr[1]

      let patternStr = "(" + res0 + ")(([^\u4e00-\u9fa5]{0,}[\u4e00-\u9fa5]{0,1}[^\u4e00-\u9fa5]{0,}){0," + spacearr[0] + "})(" + res1 + ")"
      let patternStr1 = "(" + res1 + ")(([^\u4e00-\u9fa5]{0,}[\u4e00-\u9fa5]{0,1}[^\u4e00-\u9fa5]{0,}){0," + spacearr[0] + "})(" + res0 + ")"

      let patternStr4 = "(.*)(" + res1 + ")(([^\u4e00-\u9fa5]{0,}[\u4e00-\u9fa5]{0,1}[^\u4e00-\u9fa5]{0,}){0," + spacearr[0] + "})(" + res0 + ")(.*)"
      let patternStr5 = "(.*)(" + res0 + ")(([^\u4e00-\u9fa5]{0,}[\u4e00-\u9fa5]{0,1}[^\u4e00-\u9fa5]{0,}){0," + spacearr[0] + "})(" + res1 + ")(.*)"
      if (keyarr.length == 2) {  //四德~也d10,
        //2/27修改
        let patternStrnew = `(${patternStr})|(${patternStr1})`

        let rStr = new RegExp(patternStrnew, 'g')

        newval = newval.replace(rStr, function (rs) {
          // a++
          rs = rs.replace(new RegExp(`(${res0})|(${res1})`, 'g'), function (rs1) { return '<span class="sehightText">' + rs1 + '</span>' })
          return rs

        })

      } else if (keyarr.length == 3) {


        if (keyarr[2].indexOf("$") > -1) {   //四德~也~$月d10,5,或
          keyarr[2] = keyarr[2].slice(1)
          let res2 = searchAccuracyType ? zhengzepinjie(keyarr[2]) : keyarr[2]
          let patternStr2 = "(" + res0 + ")(([^\u4e00-\u9fa5]{0,}[\u4e00-\u9fa5]{0,1}[^\u4e00-\u9fa5]{0,}){0," + spacearr[1] + "})(" + res2 + ")"
          let patternStr3 = "(" + res2 + ")(([^\u4e00-\u9fa5]{0,}[\u4e00-\u9fa5]{0,1}[^\u4e00-\u9fa5]{0,}){0," + spacearr[1] + "})(" + res0 + ")"


          let patternStrnew = `(${patternStr})|(${patternStr1})|(${patternStr2})|(${patternStr3})`
          let rStr = new RegExp(patternStrnew, 'g')

          newval = newval.replace(rStr, function (rs) {
            // a++
            rs = rs.replace(new RegExp(`(${res0})|(${res1})|(${res2})`, 'g'), function (rs1) { return '<span class="sehightText">' + rs1 + '</span>' })
            return rs

          })


        } else if (keyarr[2].indexOf("!") > -1) {  //也~四德~!有d10,5,
          keyarr[2] = keyarr[2].slice(1)
          let res2 = searchAccuracyType ? zhengzepinjie(keyarr[2]) : keyarr[2]
          let patternStr2 = "(" + res0 + ")(([^\u4e00-\u9fa5]{0,}[\u4e00-\u9fa5]{0,1}[^\u4e00-\u9fa5]{0,}){0," + spacearr[1] + "})(" + res2 + ")"
          let patternStr3 = "(" + res2 + ")(([^\u4e00-\u9fa5]{0,}[\u4e00-\u9fa5]{0,1}[^\u4e00-\u9fa5]{0,}){0," + spacearr[1] + "})(" + res0 + ")"

          newval = newval.replace(
            new RegExp(`(${patternStr4})|(${patternStr5})`, "g"), function (rs) {
              if (rs) {
                let rsk1 = rs.search(patternStr2)
                let rsk2 = rs.search(patternStr3)
                if (rsk1 == -1 && rsk2 == -1) {

                  rs = rs.replace(new RegExp(`(${patternStr})|(${patternStr1})`, 'g'), function (rs1) {
                    rs1 = rs1.replace(new RegExp(`(${res0})|(${res1})`, 'g'), function (rs2) { return '<span class="sehightText">' + rs2 + '</span>' })
                    // console.log();
                    return rs1

                  })
                  return rs

                }
              }
            }
          )

        } else {  //四德~也~云d10,5,与
          let res2 = searchAccuracyType ? zhengzepinjie(keyarr[2]) : keyarr[2]
          let patternStr2 = "(" + res0 + ")(([^\u4e00-\u9fa5]{0,}[\u4e00-\u9fa5]{0,1}[^\u4e00-\u9fa5]{0,}){0," + spacearr[1] + "})(" + res2 + ")"
          let patternStr3 = "(" + res2 + ")(([^\u4e00-\u9fa5]{0,}[\u4e00-\u9fa5]{0,1}[^\u4e00-\u9fa5]{0,}){0," + spacearr[1] + "})(" + res0 + ")"

          newval = newval.replace(
            new RegExp(`(${patternStr4})|(${patternStr5})`, "g"), function (rs) {
              if (rs) {
                let rsk1 = rs.search(patternStr2)
                let rsk2 = rs.search(patternStr3)
                if (rsk1 > -1 || rsk2 > -1) {
                  // console.log(rs, 'rsyuyu')
                  // let tempval = $1 + '<span class="sehightText">' + $2 + "</span>" + $(3 + res1.khcount) + '<span class="sehightText">' + $(5 + res1.khcount) + "</span>" + $(6 + res1.khcount + res0.khcount)
                  // if (rsk1 > -1) {
                  //   tempval = tempval.replace(
                  //     new RegExp(patternStr2, "g"), function (rs, $1, $2, $3, $4, $5, $6) {
                  //       return $1 + $(2 + res0.khcount) + '<span class="sehightText">' + $(4 + res0.khcount) + "</span>"
                  //     }
                  //   )
                  // } else {
                  //   tempval = tempval.replace(
                  //     new RegExp(patternStr3, "g"), function (rs, $1, $2, $3, $4, $5, $6) {
                  //       return '<span class="sehightText">' + $1 + "</span>" + $(2 + res2.khcount) + $(4 + res2.khcount);;
                  //     }
                  //   )
                  // }
                  rs = rs.replace(new RegExp(`(${patternStr0})|${patternStr1})|${patternStr2})|(${patternStr3})`, 'g'), function (rs1) {
                    rs1 = rs1.replace(new RegExp(`(${res0})|${res1})|(${res2})`, 'g'), function (rs2) { return '<span class="sehightText">' + rs2 + '</span>' })
                    // console.log();
                    return rs1

                  })
                  return rs
                }
              }
            }
          )

          // newval = newval.replace(
          //   new RegExp(patternStr5, "g"), function (rs, $1, $2, $3, $4, $5, $6) {
          //     if (rs) {
          //       let rsk1 = rs.search(patternStr2)
          //       let rsk2 = rs.search(patternStr3)
          //       if (rsk1 > -1 || rsk2 > -1) {
          //         let tempval = $1 + '<span class="sehightText">' + $2 + "</span>" + $(3 + res0.khcount) + '<span class="sehightText">' + $(5 + res0.khcount) + "</span>" + $(6 + res0.khcount + res1.khcount)
          //         if (rsk1 > -1) {
          //           tempval = tempval.replace(
          //             new RegExp(patternStr2, "g"), function (rs, $1, $2, $3, $4) {
          //               return $1 + $(2 + res0.khcount) + '<span class="sehightText">' + $(4 + res0.khcount) + "</span>"
          //             }
          //           )
          //         } else {
          //           tempval = tempval.replace(
          //             new RegExp(patternStr3, "g"), function (rs, $1, $2, $3, $4) {
          //               return '<span class="sehightText">' + $1 + "</span>" + $(2 + res2.khcount) + $(4 + res2.khcount);;
          //             }
          //           )
          //         }
          //         return tempval
          //       }
          //     }
          //   }
          // )

        }

      }
    }
    // return newval;
  }

  if (JSON.stringify(noteOrQa) != "{}" && noteOrQa != undefined) {

    let noteOrQaArr = noteOrQa.noteOrQa.split(" ")
    // console.log(noteOrQaArr, 'noteOrQaArr')
    for (let i = noteOrQaArr.length - 1; i >= 0; i--) {
      if (noteOrQaArr[i] == '') continue
      newval = newval.replace(
        new RegExp(noteOrQaArr[i]), //笔记与反馈 公用高亮逻辑
        (text) => {
          // if (noteOrQa.type == 1) {
          return `<span class="hightText">${text}</span>`
          // } else {//书签
          //   if (i == 0) {
          //     return `<span onclick="delshuqian()" class="shuqian bolang">${text}</span>`
          //   } else {
          //     return `<span class="bolang">${text}</span>`
          //   }
          // }
        }
      )
    }
  }
  if (markMapitem.length > 0) {
    markMapitem.forEach((markitem, markindex) => {
      let markArr = markitem.noteTarget.split(" ")
      for (let i = markArr.length - 1; i >= 0; i--) {
        if (markArr[i] == '') continue
        newval = newval.replace(
          new RegExp(markArr[i]), //笔记与反馈 公用高亮逻辑
          (text) => {

            if (i == 0) {
              return `<span onclick="delshuqian(${markitem.noteId})" class="shuqian bolang">${text}</span>`
            } else {
              return `<span class="bolang">${text}</span>`
            }

          }
        )
      }

    })

  }



  return newval


}

// Vue.prototype.$echarts = echarts

Vue.prototype.$getUUID = getUUID


// Viewer.setDefaults({
//   Options: {
//     navbar: false,
//     zoomRatio: 0.3,
//     'transition': true,
//   },
// build (e) {
//   console.log(e.type, 'init')
// },
// inited (e) {
//   console.log(e.type, 'init')
// },
// ready: function (e) {
//   console.log(e.type)
// },
// show: function (e) {

//   console.log(e, 'show')
//   //追加遮罩层样式
//   // $('.viewer-container').addClass('viewer-backdrop')
// },
// shown: function (e) {
//   console.log(e, 'shown')
// },
// hide: function (e) {
//   console.log(e, 'hide')
//   //隐藏自定义按钮
//   // $('.viewer-btn').hide()
// },
// hidden: function (e) {
//   console.log(e.type)
// },
// view: function (e) {


//   console.log(e.type)
// },
// viewed: function (e) { // 图片显示比例 100%
//   console.log(e)
//   // console.log(this.viewer.options.fullscreen, 'ee')
//   if (e.detail.image.naturalWidth > 60000) {
//     this.viewer.full()
//     this.viewer.zoomTo(0.55)
//     // this.viewer.exit()
//   }
// },
// play: function (e) {
//   console.log(e.type)
// },
// move: function (e) {
//   console.log(e.type)
// },
// moved: function (e) {
//   console.log(e.type)
// },
// rotate: function (e) {
//   console.log(e.type)
// },
// rotated: function (e) {
//   console.log(e.type)
// },
// scale: function (e) {
//   console.log(e.type)
// },
// scaled: function (e) {
//   console.log(e.type)
// },
// zoom: function (e) {
//   console.log(e.type)
// if (e.detail.ratio == 0.1) {
//   console.log(e.detail.ratio)
//   this.viewer.full()
//   this.viewer.zoomTo(0.5)

// }
// },
// zoomed: function (e) {
//   console.log(e.type)
// },
// play: function (e) {
//   console.log(e, '退出')

// },
//   stop: function (e) {
//     console.log(e, '退出')

//   },
// })

// Vue.use(Viewer)
// Vue.use(preview, {
//   fullscreenEl: true, //控制是否显示右上角全屏按钮
//   closeEl: true, //控制是否显示右上角关闭按钮
//   tapToClose: true, //点击滑动区域应关闭图库
//   shareEl: false, //控制是否显示分享按钮
//   zoomEl: false, //控制是否显示放大缩小按钮
//   counterEl: false, //控制是否显示左上角图片数量按钮
//   arrowEl: false,  //控制如图的左右箭头（pc浏览器模拟手机时）
//   tapToToggleControls: true, //点击应切换控件的可见性
//   clickToCloseNonZoomable: true, //点击图片应关闭图库，仅当图像小于视口的大小时
//   // spacing: 0.5
// })

zhLocale.el.pagination = {
  goto: '前往',
  pagesize: '条/页',
  total: '共 {total} 條',
  pageClassifier: '页'
}

Vue.use(ElementUI, {
  locale: zhLocale,
})
Vue.config.productionTip = false
Vue.config.deepClone = function (data) {
  return JSON.parse(JSON.stringify(data))
}

!(function (win, doc) {
  function change () {
    const width = document.documentElement.clientWidth
    window.echartRem = (width > 1200 ? width : 1200) / 100
    document.documentElement.style.fontSize = window.echartRem + "px"
    document.getElementsByTagName("body")[0].style.fontSize =
      window.echartRem + "px"
  }
  win.addEventListener("resize", change, false)
  win.addEventListener("DOMContentLoaded", change, false)
})(window, document)

Vue.prototype.baseImgPath = window.__baseUrl__ + "/profile/business/book/"

Vue.prototype.downBlobFile = function (blob, newFileName, type = 1) {
  // let newblob = new Blob([blob], { type: `${type};charset=utf-8` })
  var link = document.createElement("a")
  link.href = window.URL.createObjectURL(blob)
  // link.download = newFileName + type ? '.' + type : ".xlsx"
  if (type == 1) {
    link.download = newFileName + ".xlsx"
  } else {
    link.download = newFileName
  }
  const body = document.querySelector("body")
  body.appendChild(link)
  link.click()
  body.removeChild(link)
  return true
}
Vue.prototype.copyText = function (value, that) {
  const input = document.createElement("input")
  document.body.appendChild(input)
  input.setAttribute("value", value)
  input.select()
  if (document.execCommand("copy")) {
    document.execCommand("copy")
    that.$message.success("复制成功")
  }
  document.body.removeChild(input)
}
Vue.prototype.hightLighyt = (str, keyword) => {
  let zhengze = zhengzepinjienew(keyword)
  const reg = new RegExp(zhengze, "g")
  str = str.replace(reg, d => {
    // return `<span style="color:#3366CC;background:#ffff00">${d}</span>`;
    return `<span style="background:#ffff00">${d}</span>`
  })

  return str
}
Vue.prototype.underLine = (str, keyword) => {

  const reg = new RegExp(keyword, "g")
  str = str.replace(reg, d => {
    return `<span class="bolang">${d}</span>`
  })

  return str
}

// 主要是icon的闪烁效果
Vue.prototype.viewFootNoteIcon = (id, imgpage = '') => {
  // console.log(window["page" + id].dataset);
  const ele = window["page" + id] || window["img-page" + imgpage]
  if (ele) {
    // if (window["page" + id].dataset.sign !== "footNote") {
    //   return;
    // }

    ele.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "nearest"
    })
    window["page" + id].classList.add("twinkle")
    setTimeout(() => {
      window["page" + id].classList.remove("twinkle")
    }, 2000)
  }
}
Vue.prototype.formParam = obj => {
  let str = "?"
  for (let key in obj) {
    str += key + "=" + obj[key] + "&"
  }
  return str
}

// Vue.use({
//   install (Vue) {
//     Vue.prototype.$bus = Vue
//   }
// })

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
  beforeCreate () {
    Vue.prototype.$bus = this
  }
})



// WEBPACK FOOTER //
// ./src/main.js